import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ViewerModalComponent } from './viewer-modal.component';

// Substituto in-repo do NgxIonicImageViewerModule (ver viewer-modal.component.ts).
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [CommonModule, TranslateModule],
	declarations: [ViewerModalComponent],
	exports: [ViewerModalComponent],
})
export class MpImageViewerModule {}
